import React, { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
Box,
Typography,
Accordion,
AccordionSummary,
AccordionDetails,
Divider,
Button,
Link,
Stack,
} from "@mui/material";
import GetEBookButton from "./GetEBookButton";

const faqs = [
{
    question: "What age group is this for?",
    answer:
        "Perfect for kids ages 4–10 and easily adaptable if you have siblings in different age ranges.",
},
{
    question: "Is this a physical or digital product?",
    answer:
        "It’s a printable digital download (PDF) — ready to use instantly after purchase. Print it at home or view it on your tablet.",
},
{
    question: "Is it just for parents?",
    answer:
        "It’s been created especially for parents, but teachers, counsellors, and therapists love it too. The activities can be seamlessly adapted for classrooms or child-therapy sessions.",
},
{
    question: "Do I need any special materials?",
    answer:
        "Not at all! Just a printer, a few crayons or markers, and your child’s curious mind.",
},
{
    question: "Can I reuse it?",
    answer:
        "Yes! You can print the workbook as many times as you like for personal or family use, perfect for re-visiting activities as your child grows.",
},
{
    question: "Is it backed by research?",
    answer:
        "Absolutely. Every tool and prompt is grounded in Positive Psychology research, translated into fun, family-friendly language that kids actually enjoy.",
},
{
    question: "How can therapists or educators use it?",
    answer:
        "If you’d like to use this in your professional practice or school setting, reach out to us, we’ll guide you through simple ways to adapt it (and share licensing options, if needed).",
},
{
    question: "Is it easy for parents to use?",
    answer:
        "Completely! You don’t need any background in psychology. Each page includes clear guidance, reflection prompts, and activity examples, so you’ll always know what to do and how to start meaningful conversations with your child right away.",
},
];

export default function FrequentlyAskedQuestions() {
const [expanded, setExpanded] = useState(false);

const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
};

return (
    <Box
        sx={{
            mt: 2,
            mx: "auto",
            py: { xs: 4, md: 8 },
            px: { xs: 2, md: 4 },
            bgcolor: "custom.beige",
        }}
    >
        <Stack spacing={2} alignItems="center" mb={4}>
            <Typography
                variant="subtitle1"
                sx={{
                    color: "custom.blue",
                    fontSize: 18,
                }}
            >
                You Asked, We Answered
            </Typography>
            <Typography
                variant="h2"
                align="center"
                sx={{
                    fontWeight: 400,
                    fontSize: { xs: 32, md: 42 },
                    color: "rgba(28, 30, 46, 1)",
                    lineHeight: 1.1,
                }}
            >
                <strong>Frequently</strong>
                <br />
                <strong>Asked</strong>
                <br />
                <strong>Questions</strong>
            </Typography>
            <Typography
                variant="body1"
                align="center"
                sx={{
                    fontSize: 18,
                    color: "rgba(74, 74, 74, 1)",
                    maxWidth: 700,
                }}
            >
                We love connecting with you and answering your burning questions about
                the Happy US-Kids Program. If you don’t see your question in the <strong>FAQs</strong>, you can{" "}
                <Link href="mailto:hello@sarasjournal.com" underline="hover">
                    hello@sarasjournal.com
                </Link>{" "}
                us directly and we’ll return the favor within <strong>24 business hours.</strong>
            </Typography>
        </Stack>

        <Box mb={5}>
            {faqs.map((faq, idx) => (
                <Box key={faq.question}>
                    <Accordion
                        expanded={expanded === idx}
                        onChange={handleChange(idx)}
                        sx={{
                            boxShadow: "none",
                            "&:before": { display: "none" },
                            background: "transparent",
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`faq-content-${idx}`}
                            id={`faq-header-${idx}`}
                            sx={{
                                fontWeight: 700,
                                fontSize: 20,
                                color: "rgba(24, 24, 24, 1)",
                                minHeight: 56,
                            }}
                        >
                            {faq.question}
                        </AccordionSummary>
                        <AccordionDetails
                            sx={{
                                fontSize: 18,
                                color: "rgba(74, 74, 74, 1)",
                                pb: 2,
                            }}
                        >
                            {faq.answer}
                        </AccordionDetails>
                    </Accordion>
                    {idx < faqs.length - 1 && <Divider sx={{ my: 1 }} />}
                </Box>
            ))}
        </Box>
            <GetEBookButton />
    </Box>
);
}